/* Cart drawer Veloura PT - port van de clovire.se-drawer (look en gedrag van UpCart).
   Verschillen met clovire.se: EUR-notatie, Portugese teksten, verzendbescherming wordt
   standaard toegevoegd (opt-out per sessie) en Kaching-kortingstitels worden vertaald.
   Implementeert dezelfde interface als Dawn's <cart-drawer> (open, close, renderContents,
   getSectionsToRender, setActiveElement), zodat product-form.js en de eigen secties
   er zonder aanpassing mee werken. */

(function () {
  if (customElements.get('cart-drawer')) return;

  const ICON_TRASH =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" aria-hidden="true"><path d="M11.5 8.25a.75.75 0 0 1 .75.75v4.25a.75.75 0 0 1-1.5 0v-4.25a.75.75 0 0 1 .75-.75Z"></path><path d="M9.25 9a.75.75 0 0 0-1.5 0v4.25a.75.75 0 0 0 1.5 0v-4.25Z"></path><path fill-rule="evenodd" d="M7.25 5.25a2.75 2.75 0 0 1 5.5 0h3a.75.75 0 0 1 0 1.5h-.75v5.45c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311c-.642.327-1.482.327-3.162.327h-.4c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311c-.327-.642-.327-1.482-.327-3.162v-5.45h-.75a.75.75 0 0 1 0-1.5h3Zm1.5 0a1.25 1.25 0 1 1 2.5 0h-2.5Zm-2.25 1.5h7v5.45c0 .865-.001 1.423-.036 1.848-.033.408-.09.559-.128.633a1.5 1.5 0 0 1-.655.655c-.074.038-.225.095-.633.128-.425.035-.983.036-1.848.036h-.4c-.865 0-1.423-.001-1.848-.036-.408-.033-.559-.09-.633-.128a1.5 1.5 0 0 1-.656-.655c-.037-.074-.094-.225-.127-.633-.035-.425-.036-.983-.036-1.848v-5.45Z"></path></svg>';
  const ICON_MINUS =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" aria-hidden="true"><path fill-rule="evenodd" d="M5 10c0-.414.336-.75.75-.75h8.5c.414 0 .75.336.75.75s-.336.75-.75.75h-8.5c-.414 0-.75-.336-.75-.75Z"></path></svg>';
  const ICON_PLUS =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" aria-hidden="true"><path d="M10.75 5.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75v3.5h-3.5c-.414 0-.75.336-.75.75s.336.75.75.75h3.5v3.5c0 .414.336.75.75.75s.75-.336.75-.75v-3.5h3.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-3.5v-3.5Z"></path></svg>';
  const ICON_TAG =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" aria-hidden="true"><path fill-rule="evenodd" d="M8.575 4.649a3.75 3.75 0 0 1 2.7-1.149h1.975a3.25 3.25 0 0 1 3.25 3.25v2.187a3.25 3.25 0 0 1-.996 2.34l-4.747 4.572a2.5 2.5 0 0 1-3.502-.033l-2.898-2.898a2.75 2.75 0 0 1-.036-3.852l4.254-4.417Zm4.425 3.351a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path></svg>';

  const TIMER_KEY = 'clv-uc-timer-start';
  const ADDON_OFF_KEY = 'vlr-uc-addon-off';

  function money(cents) {
    const n = (Number(cents) || 0) / 100;
    const parts = n.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '\u20ac' + parts[0] + ',' + parts[1];
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  function sized(url, width) {
    if (!url) return '';
    try {
      const u = new URL(url, window.location.origin);
      u.searchParams.set('width', width);
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  // Kaching-deals hebben Franse titels (bv. "2 achetes = 2 gratuits")
  function ptTitle(t) {
    return String(t || '')
      .replace(/achet\u00e9s/gi, 'comprados')
      .replace(/achet\u00e9/gi, 'comprado')
      .replace(/gratuits/gi, 'gr\u00e1tis')
      .replace(/gratuit/gi, 'gr\u00e1tis')
      .replace(/=/g, '+');
  }

  function sget(k) {
    try { return sessionStorage.getItem(k); } catch (e) { return null; }
  }

  function sset(k, v) {
    try { sessionStorage.setItem(k, v); } catch (e) {}
  }

  function tagHtml(title) {
    return '<span class="clv-uc__tag">' + ICON_TAG + '<span>' + esc(ptTitle(title)) + '</span></span>';
  }

  class CartDrawer extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.cart = null;
      this.busy = false;
      this.addonVariant = Number(this.dataset.addonVariant) || null;
      this.addonHandle = this.dataset.addonHandle || '';
      this.addonAuto = this.dataset.addonAuto === 'true';

      this.querySelectorAll('[data-uc-money]').forEach((el) => (el.textContent = money(el.dataset.ucMoney)));
      this.querySelectorAll('[data-uc-close]').forEach((el) => el.addEventListener('click', () => this.close()));
      this.addEventListener('keyup', (e) => e.code === 'Escape' && this.close());

      this.itemsEl = this.querySelector('[data-uc-items]');
      this.itemsEl.addEventListener('click', (e) => this.onItemsClick(e));
      this.itemsEl.addEventListener('change', (e) => this.onQtyInput(e));

      const toggle = this.querySelector('[data-uc-addon-toggle]');
      if (toggle) toggle.addEventListener('click', () => this.toggleAddon());

      this.setHeaderCartIconAccessibility();
      this.refresh();

      // Wijzigingen van buitenaf (Kaching, Standard Actions, /cart-pagina) -> opnieuw ophalen
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event && event.source === 'cart-drawer') return;
          this.refresh();
        });
      }
    }

    setHeaderCartIconAccessibility() {
      const bind = () => {
        const icon = document.querySelector('#cart-icon-bubble');
        if (!icon || icon.dataset.clvUc) return;
        icon.dataset.clvUc = '1';
        icon.setAttribute('role', 'button');
        icon.setAttribute('aria-haspopup', 'dialog');
        icon.addEventListener('click', (event) => {
          event.preventDefault();
          this.open(icon);
        });
        icon.addEventListener('keydown', (event) => {
          if (event.code.toUpperCase() === 'SPACE') {
            event.preventDefault();
            this.open(icon);
          }
        });
      };
      bind();
      document.addEventListener('DOMContentLoaded', bind);
    }

    /* ---- Dawn-interface ---- */
    getSectionsToRender() {
      return [{ id: 'cart-icon-bubble' }];
    }

    setActiveElement(element) {
      this.activeElement = element;
    }

    renderContents(parsedState) {
      if (parsedState && parsedState.sections && parsedState.sections['cart-icon-bubble']) {
        this.updateBubble(parsedState.sections['cart-icon-bubble']);
      }
      this.refresh().then(() => this.open());
    }

    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);
      this.classList.add('active');
      document.body.classList.add('clv-uc-open');
      this.startTimer();
      this.render();
      const card = this.querySelector('.clv-uc__card');
      setTimeout(() => card && card.focus({ preventScroll: true }), 50);
    }

    close() {
      this.classList.remove('active');
      document.body.classList.remove('clv-uc-open');
      this.stopTimer();
      if (this.activeElement && this.activeElement.focus) this.activeElement.focus({ preventScroll: true });
    }

    /* ---- Data ---- */
    async refresh() {
      try {
        const res = await fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', {
          headers: { Accept: 'application/json' },
        });
        this.cart = await res.json();
      } catch (e) {
        console.error(e);
      }
      await this.ensureAddonConsistency();
      this.render();
      return this.cart;
    }

    isAddon(item) {
      return (this.addonVariant && item.variant_id === this.addonVariant) || item.handle === this.addonHandle;
    }

    async ensureAddonConsistency() {
      if (!this.cart) return;
      const regular = this.cart.items.filter((i) => !this.isAddon(i));
      const addon = this.cart.items.find((i) => this.isAddon(i));
      if (!regular.length && addon) {
        await this.change(addon.key, 0, false);
      } else if (regular.length && !addon && this.addonAuto && this.addonVariant && sget(ADDON_OFF_KEY) !== '1' && !this._autoAdding) {
        this._autoAdding = true;
        await this.addAddon();
        this._autoAdding = false;
      }
    }

    async change(key, quantity, rerender = true) {
      this.classList.add('is-loading');
      try {
        const res = await fetch((window.routes && window.routes.cart_change_url) || '/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity, sections: ['cart-icon-bubble'] }),
        });
        const data = await res.json();
        if (data && data.items) {
          this.cart = data;
          if (data.sections && data.sections['cart-icon-bubble']) this.updateBubble(data.sections['cart-icon-bubble']);
        }
      } catch (e) {
        console.error(e);
      }
      this.classList.remove('is-loading');
      if (rerender) {
        await this.ensureAddonConsistency();
        this.render();
        this.publish();
      }
    }

    async toggleAddon() {
      if (!this.addonVariant || this.busy) return;
      this.busy = true;
      const btn = this.querySelector('[data-uc-addon-toggle]');
      btn.disabled = true;
      const addon = this.cart && this.cart.items.find((i) => this.isAddon(i));
      if (addon) {
        sset(ADDON_OFF_KEY, '1');
        await this.change(addon.key, 0);
      } else {
        sset(ADDON_OFF_KEY, '0');
        await this.addAddon();
        this.render();
        this.publish();
      }
      btn.disabled = false;
      this.busy = false;
    }

    async addAddon() {
      this.classList.add('is-loading');
      try {
        await fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: this.addonVariant, quantity: 1 }] }),
        });
        const res = await fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', {
          headers: { Accept: 'application/json' },
        });
        this.cart = await res.json();
      } catch (e) {
        console.error(e);
      }
      this.classList.remove('is-loading');
      this.fetchBubble();
    }

    publish() {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer', cartData: this.cart });
      }
    }

    updateBubble(html) {
      const target = document.getElementById('cart-icon-bubble');
      if (!target || !html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const src = doc.querySelector('.shopify-section') || doc.body;
      target.innerHTML = src.innerHTML;
    }

    async fetchBubble() {
      try {
        const res = await fetch(window.location.pathname + '?sections=cart-icon-bubble');
        const data = await res.json();
        this.updateBubble(data['cart-icon-bubble']);
      } catch (e) {}
    }

    /* ---- Events ---- */
    onItemsClick(e) {
      const btn = e.target.closest('button[data-action]');
      if (!btn) return;
      const li = btn.closest('[data-key]');
      const key = li.dataset.key;
      const qty = Number(li.dataset.qty);
      const action = btn.dataset.action;
      if (action === 'minus') this.change(key, Math.max(0, qty - 1));
      if (action === 'plus') this.change(key, qty + 1);
      if (action === 'remove') this.change(key, 0);
    }

    onQtyInput(e) {
      const input = e.target.closest('input[data-qty-input]');
      if (!input) return;
      const li = input.closest('[data-key]');
      const val = Math.max(0, parseInt(input.value, 10) || 0);
      this.change(li.dataset.key, val);
    }

    /* ---- Timer ---- */
    startTimer() {
      const total = Number(this.dataset.timer) || 600;
      let start = 0;
      try {
        start = Number(sessionStorage.getItem(TIMER_KEY)) || 0;
      } catch (e) {}
      const now = Date.now();
      if (!start || now - start >= total * 1000) {
        start = now;
        try {
          sessionStorage.setItem(TIMER_KEY, String(start));
        } catch (e) {}
      }
      this._timerStart = start;
      this.tick();
      this.stopTimer();
      this._timer = setInterval(() => this.tick(), 1000);
    }

    stopTimer() {
      if (this._timer) clearInterval(this._timer);
      this._timer = null;
    }

    tick() {
      const total = Number(this.dataset.timer) || 600;
      let left = total - Math.floor((Date.now() - this._timerStart) / 1000);
      if (left <= 0) {
        this._timerStart = Date.now();
        try {
          sessionStorage.setItem(TIMER_KEY, String(this._timerStart));
        } catch (e) {}
        left = total;
      }
      const mm = String(Math.floor(left / 60)).padStart(2, '0');
      const ss = String(left % 60).padStart(2, '0');
      const el = this.querySelector('[data-uc-timer]');
      if (el) el.textContent = mm + ':' + ss;
    }

    /* ---- Render ---- */
    render() {
      const cart = this.cart;
      if (!cart) return;
      const items = cart.items.filter((i) => !this.isAddon(i));
      const addon = cart.items.find((i) => this.isAddon(i));
      const count = items.reduce((s, i) => s + i.quantity, 0);

      this.querySelector('[data-uc-count]').textContent = count;
      this.classList.toggle('is-empty', items.length === 0);

      // Rewards (basis: aantal producten, drempel 1)
      const reached = count >= 1;
      this.querySelector('[data-uc-rewards-message]').innerHTML = reached
        ? '<p>Parab\u00e9ns, desbloqueou o envio gr\u00e1tis \ud83c\udf81</p>'
        : '<p>Adicione um produto para desbloquear o envio gr\u00e1tis</p>';
      this.querySelector('[data-uc-fill]').style.width = reached ? '100%' : '0%';
      this.querySelector('[data-uc-milestone]').classList.toggle('is-complete', reached);

      // Items
      this.itemsEl.innerHTML = items.map((item) => this.itemHtml(item)).join('');

      // Addon
      const toggle = this.querySelector('[data-uc-addon-toggle]');
      if (toggle) toggle.setAttribute('aria-checked', addon ? 'true' : 'false');

      // Discounts
      const titles = [];
      cart.items.forEach((i) =>
        (i.line_level_discount_allocations || []).forEach((a) => {
          const t = a.discount_application && a.discount_application.title;
          if (t && titles.indexOf(t) === -1) titles.push(t);
        })
      );
      (cart.cart_level_discount_applications || []).forEach((a) => {
        if (a.title && titles.indexOf(a.title) === -1) titles.push(a.title);
      });
      const summary = this.querySelector('[data-uc-summary]');
      if (cart.total_discount > 0) {
        summary.hidden = false;
        this.querySelector('[data-uc-summary-tags]').innerHTML = titles.map(tagHtml).join('');
        this.querySelector('[data-uc-summary-total]').textContent = '\u2212' + money(cart.total_discount);
      } else {
        summary.hidden = true;
      }

      this.querySelector('[data-uc-total]').textContent = money(cart.total_price);
    }

    itemHtml(item) {
      const opts = (item.options_with_values || [])
        .filter((o) => !(o.name === 'Title' && o.value === 'Default Title'))
        .map((o) => esc(o.name) + ': ' + esc(o.value))
        .join(', ');
      const discounted = item.final_line_price < item.original_line_price;
      const titles = [];
      (item.line_level_discount_allocations || []).forEach((a) => {
        const t = a.discount_application && a.discount_application.title;
        if (t && titles.indexOf(t) === -1) titles.push(t);
      });
      const img = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
      return (
        '<li class="clv-uc__item" data-key="' + esc(item.key) + '" data-qty="' + item.quantity + '">' +
          '<div class="clv-uc__tile"><div class="clv-uc__tile-content">' +
            '<a class="clv-uc__tile-image" href="' + esc(item.url) + '">' +
              (img ? '<img src="' + esc(sized(img, 176)) + '" alt="' + esc(item.product_title) + '" width="88" height="88" loading="lazy">' : '') +
            '</a>' +
            '<div class="clv-uc__tile-info">' +
              '<div class="clv-uc__tile-header">' +
                '<h4 class="clv-uc__tile-title"><a href="' + esc(item.url) + '">' + esc(item.product_title) + '</a></h4>' +
                '<button type="button" class="clv-uc__remove" data-action="remove" aria-label="Remover">' + ICON_TRASH + '</button>' +
              '</div>' +
              '<div class="clv-uc__tile-variant">' + (opts ? '<span class="clv-uc__kv">' + opts + '</span>' : '') + '</div>' +
              '<div class="clv-uc__pricing"><span class="clv-uc__price-group">' +
                (discounted ? '<span class="clv-uc__compare">' + money(item.original_line_price) + '</span>' : '') +
                '<span class="clv-uc__price">' + money(item.final_line_price) + '</span>' +
              '</span></div>' +
              '<div class="clv-uc__controls">' +
                '<div class="clv-uc__qty">' +
                  '<button type="button" data-action="minus" aria-label="Diminuir quantidade">' + ICON_MINUS + '</button>' +
                  '<input type="number" min="0" inputmode="numeric" value="' + item.quantity + '" data-qty-input aria-label="Quantidade">' +
                  '<button type="button" data-action="plus" aria-label="Aumentar quantidade">' + ICON_PLUS + '</button>' +
                '</div>' +
                (titles.length ? '<div class="clv-uc__tags">' + titles.map(tagHtml).join('') + '</div>' : '') +
              '</div>' +
            '</div>' +
          '</div></div>' +
        '</li>'
      );
    }
  }

  customElements.define('cart-drawer', CartDrawer);
})();
